<template>
	<div class="container"><slot></slot></div>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.container {
	@media screen and (max-width: 1280px) {
		padding-left: 2rem;
	}
}
</style>
